<template>
  <div id="grid-videos">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>
      <template>
        <v-layout justify-center>
          <v-flex lg12>
            <v-data-table
              :headers="headers"
              :items="itemsReporteria"
              :rows-per-page-items="rowsTable"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.proceso }}</td>
                <td class="text-xs-left">{{ props.item.reporte }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Ver Reporte"
                    @click="viewReporte(props.item.id)"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "grid-reporteria",
  components: {
    Loading,
  },
  props: {
    rowsTable: "",
    deleteIcon: "",
  },
  data() {
    return {
      loading: false,
      alerta: false,
      itemsReporteria: [],
      btnEdit: false,
      headers: [
        { text: "Proceso", align: "left", sortable: false, value: "proceso" },
        { text: "Reporte", align: "left", sortable: false, value: "reporte" },
        {
          text: "Acciones",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  mounted() {},
  created() {
    this.loadDataReporteria();
  },
  computed: {},
  methods: {
    async loadDataReporteria() {
      this.loading = true;
      this.itemsReporteria = await this.loadReporteriaAll();
      this.loading = false;
    },
    async loadReporteriaAll() {
      return await axios
        .get("/reportes/getAll")
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    viewReporte(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GraficasReporteria",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
  },
};
</script>
